/**
 * Small shared header used by the Sales-tab widgets so they all read the
 * same way — title on the left, optional subtitle, optional right-side slot.
 */

import React from 'react';

interface Props {
  title: string;
  subtitle?: React.ReactNode;
  right?: React.ReactNode;
}

const WidgetHeader: React.FC<Props> = ({ title, subtitle, right }) => (
  <div style={styles.row}>
    <div style={styles.titleBlock}>
      <h3 style={styles.title}>{title}</h3>
      {subtitle && <div style={styles.subtitle}>{subtitle}</div>}
    </div>
    {right && <div style={styles.right}>{right}</div>}
  </div>
);

const styles: Record<string, React.CSSProperties> = {
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 12,
    flexWrap: 'wrap',
  },
  titleBlock: { display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 },
  title: {
    margin: 0,
    fontSize: 16,
    fontWeight: 700,
    color: 'var(--fg-1)',
    fontFamily: 'var(--font-display)',
    letterSpacing: '-0.01em',
  },
  subtitle: { fontSize: 12, color: 'var(--fg-4)' },
  right: { display: 'flex', alignItems: 'center', gap: 8 },
};

export default WidgetHeader;
